import React, { useState, useEffect } from "react";
import { Select, MenuItem, FormControl } from "@mui/material";

function MarkerSymbolSelect(props) {
  const { updateMarkerSymbol, dist, defaultMarkerSymbol = "circle" } = props;
  const [markerSymbol, setMarkerSymbol] = useState(defaultMarkerSymbol);

  useEffect(() => {
    setMarkerSymbol(defaultMarkerSymbol);
  }, [defaultMarkerSymbol]);

  const handleChange = (event) => {
    setMarkerSymbol(event.target.value);
    updateMarkerSymbol(event.target.value, dist);
  };

  const symbolOptions = [
    { value: "circle", label: "●", display: "●" },
    { value: "square", label: "■", display: "■" },
    { value: "diamond", label: "◆", display: "◆" },
    { value: "triangle-up", label: "▲", display: "▲" },
    { value: "triangle-down", label: "▼", display: "▼" },
    { value: "cross", label: "+", display: "+" },
    { value: "x", label: "×", display: "×" },
    { value: "star", label: "★", display: "★" },
  ];

  return (
    <FormControl
      size="small"
      variant="standard"
      style={{ width: 35, justifySelf: "center" }}
    >
      <Select
        value={markerSymbol}
        onChange={handleChange}
        label="Marker Symbol"
        style={{ padding: 0, height: "20px", width: "35px" }}
        renderValue={(value) => {
          const option = symbolOptions.find((opt) => opt.value === value);
          return option ? <span style={{ fontSize: "16px" }}>{option.display}</span> : value;
        }}
      >
        {symbolOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            <span style={{ fontSize: "16px" }}>{option.display}</span>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default MarkerSymbolSelect;

